var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"kvass-media-image__thumbnail",style:(_vm.style),on:{"click":function($event){return _vm.$emit('click')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }